import React, { HTMLProps, ReactNode, useRef, useState } from 'react'
import MovingHeader, { MovingHeaderSize } from './components/MovingHeader'
import { twMerge } from 'tailwind-merge'
import { useIsMobile } from '../../utils/helpers'

interface MovingBackgroundProps {
  classes?: {
    wrapper?: string
    background?: string
  }
  component?: string
  mobileComponent?: string
  children?: ReactNode
  size?: MovingHeaderSize
  animate?: boolean
  backgroundProps?: HTMLProps<HTMLDivElement>
}

const MovingBackground = ({
    classes,
    component,
    children,
    mobileComponent,
    size = MovingHeaderSize.BIG,
    animate,
    backgroundProps,
}: MovingBackgroundProps) => {
    const backgroundRef = useRef<HTMLDivElement>(null)
    const [coords, setCoords] = useState({ x: 0, y: 0 })
    const isMobile = useIsMobile()
    const moveBackground = (e: MouseEvent) => {
        const x = coords.x + e.movementX / 20
        const y = coords.y + e.movementY / 20
        const value = `translate3d(${x + 'px'}, ${y + 'px'}, 0)`
    backgroundRef.current?.style.setProperty('transform', value)
    setCoords({ x, y })
    }
    const onMouseMove = (e: MouseEvent) => {
        moveBackground(e)
    }

    return (
        <div
            className={twMerge('overflow-hidden relative', classes?.wrapper)}
            onMouseMove={(e) => {
                // @ts-ignore
                component && onMouseMove(e)
            }}
        >
            {(component || mobileComponent) && (
                <MovingHeader
                    backgroundRef={backgroundRef}
                    component={component}
                    mobileComponent={
                        mobileComponent ?? (size === MovingHeaderSize.SMALL && isMobile ? component : undefined)
                    }
                    className={twMerge(classes?.background)}
                    size={size}
                    animate={animate}
                    backgroundProps={backgroundProps}
                />
            )}
            {children}
        </div>
    )
}

export default MovingBackground
